import React, {useEffect, useState} from "react";
import {useJson} from "../../shared/utils/json";
import {PageProvider} from "../../shared/contexts/page";
import {CustomerProvider} from "../../shared/contexts/customer";
import {PaymentsProvider, usePaymentsMutator} from "../../shared/contexts/payments";
import {PaymentView} from "../../shared/containers/payment-view";
import {Modal} from '../../shared/components/modals';
import {text} from '../../shared/utils/i18n';
import {applePaySupported} from '../../shared/utils/payments';
import {createRoot} from "react-dom/client";
import {getAndStripAttribute} from "../../shared/utils/dom-container-util";
import {flushSync} from "react-dom";

const domContainerId = '#expressCheckout-payment-container';
const paymentsModalName = 'expresscheckout-cart-modal';

const iconSizeStyle = {
    fontSize: '2em'
};

const reFactorClass = (paymentClass) => {
    if(paymentClass === 'apple-pay') {
        return paymentClass.substr(0, paymentClass.lastIndexOf('-pay'));
    } else if (paymentClass === 'google-pay') {
        return paymentClass.replace('-pay', '_pay');
    }
    return paymentClass;
};

const ExpressCheckoutBtn = ({ text, tooltip, onExpressBtn, needToShowFreeEnrollmentPopUp }) => {
    if(needToShowFreeEnrollmentPopUp) {
        return <a href="#" type="button" role="button" id="expressChkoutOnclickHrefId" className="express-checkout-btn btn btn-secondary" disabled="disabled" data-toggle="tooltip" title={tooltip} aria-label={`${text}: ${tooltip}`}>{text}</a>;
    } 
        return <a href="#" onClick={onExpressBtn} type="button" role="button" id="expressChkoutOnclickHrefId" className="express-checkout-btn btn btn-secondary">{text}</a>;
    
};

const ExpressCheckoutPayments = ({model, needToShowFreeEnrollmentPopUp, activePaymentMethods, markets}) => {
    const cardMessage = model.creditCardMessage;
    const runEnv = model.digitalWalletRunEnvironment;
    const googlePayMerchantId = model.googlePayMerchantId;
    const { showModal, hideModal } = usePaymentsMutator();

    const checkLRPPVTotal = () => {
        // helper function defined in global.js
        // eslint-disable-next-line no-undef
        if(!isEnrollToLRPValid()){
            // helper function defined in global.js
            // eslint-disable-next-line no-undef
            enrollToLRP0PVModal();
        } else {
            // helper function defined in global.js
             
            showExpressCheckoutModal();
        }
    };

    const showExpressCheckoutModal = () => {
        showModal(paymentsModalName, <Modal title={text('text.mycart.expressCheckout.header')} size='medium' close={() => hideModal(paymentsModalName)}>
            <PaymentView markets={markets} initialMode='express' showList={true} citMitMessage={cardMessage} digitalWalletEnv={runEnv} googlePayMerchantId={googlePayMerchantId} closeModal={hideModal} bottomBackButton={false} modelName={paymentsModalName} recaptchaKey={model.recaptchaKey}/>
        </Modal>);
    };

    return (
        <div className="express-checkout-container">
            <ExpressCheckoutBtn text={text("text.mycart.expressCheckout.header")} tooltip={text("fewa.modal.upsell.tooltip")} onExpressBtn={checkLRPPVTotal} needToShowFreeEnrollmentPopUp={needToShowFreeEnrollmentPopUp}/>

            <div className="express-checkout-options">
                {
                    activePaymentMethods.split(',').map(payment => {
                        if(payment.length !== 0 && (payment !== 'apple-pay' || applePaySupported())) {
                            return <i tabIndex="0" key={payment} data-testid="icon-element" className={`icon--payment-${reFactorClass(payment)} icon--xl`} aria-label={reFactorClass(payment)} style={iconSizeStyle}/>;
                        }
                    })
                }
            </div>
        </div>
    );
};

const ExpressCheckoutPaymentsContainer = (props) => {
    const { parseJson } = useJson();
    const model = parseJson(props.model);
    const markets = props.markets;
    const customerId = model.customerId || model.uid;
    const cartPaymentId = model.cartPaymentId;
    const activePaymentMethods = props.expressPayments || '';
    const [needToShowFreeEnrollmentPopUp, setNeedToShowFreeEnrollmentPopUp] = useState(model.needToShowFreeEnrollmentPopUp);

    useEffect(() => {
        window.handleUpdateExpressCheckoutButton = handleUpdateExpressCheckoutButton;
        
        // Cleanup function to remove global function reference
        return () => {
            if (window.handleUpdateExpressCheckoutButton === handleUpdateExpressCheckoutButton) {
                delete window.handleUpdateExpressCheckoutButton;
            }
        };
    }, []);

    function handleUpdateExpressCheckoutButton(needToShowFreeEnrollmentPopUp) {
      flushSync(() => {
        setNeedToShowFreeEnrollmentPopUp(needToShowFreeEnrollmentPopUp);
      });
    }

    return (
        <PageProvider>
            <CustomerProvider uid={model.uid} customerId={customerId} language={model.language}>
                <PaymentsProvider context='express-checkout' activePaymentMethods={activePaymentMethods} cartPaymentId={cartPaymentId} ccNonce={model.ccNonce}>
                    <ExpressCheckoutPayments model={model} needToShowFreeEnrollmentPopUp={needToShowFreeEnrollmentPopUp} markets={markets} activePaymentMethods={activePaymentMethods}/>
                </PaymentsProvider>
            </CustomerProvider>
        </PageProvider>
    );
};

const domContainer = document.querySelector(domContainerId);
if (domContainer) {
  const markets = getAndStripAttribute("data-markets", domContainer);
  const model = getAndStripAttribute("data-model", domContainer);
  const expressPayments = getAndStripAttribute("data-express-payments", domContainer);
  const root = createRoot(domContainer);
  root.render(<ExpressCheckoutPaymentsContainer markets={markets} model={model} expressPayments={expressPayments}/>);
}
